var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30625 14H0.4V4.65625H3.30625V14ZM1.8375 3.40625C0.93125 3.40625 0.18125 2.625 0.18125 1.6875C0.18125 0.78125 0.93125 0.03125 1.8375 0.03125C2.775 0.03125 3.525 0.78125 3.525 1.6875C3.525 2.625 2.775 3.40625 1.8375 3.40625ZM14.15 14H11.275V9.46875C11.275 8.375 11.2438 7 9.74375 7C8.24375 7 8.025 8.15625 8.025 9.375V14H5.11875V4.65625H7.9V5.9375H7.93125C8.3375 5.21875 9.275 4.4375 10.6813 4.4375C13.6188 4.4375 14.1813 6.375 14.1813 8.875V14H14.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f4af911f33237b8e3e50ec1c6d0ff643.svg";
export { ForwardRef as ReactComponent };